import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const AcceptableUsePolicy = () => {
  return (
    <>
      <SEO 
        title="Acceptable Use Policy - Abacies Logiciels"
        description="Review Abacies Logiciels' Acceptable Use Policy outlining permitted and prohibited uses of our services, platforms, and technology solutions."
        keywords="acceptable use policy, AUP, terms of use, service usage policy, user guidelines, platform rules"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Acceptable Use Policy
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Acceptable Use Policy page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Acceptable Use Policy. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default AcceptableUsePolicy;
